// src/api/workouts.js
import { format } from "date-fns";
import api from "./client"; // default export

// 월 요약
export const getMonthSummary = (monthDate) => {
    const ym = format(monthDate, "yyyy-MM");
    return api(`/health/workouts/summary?month=${ym}`);
};

// 일자 기록
export const getDayWorkouts = (dateStr) =>
    api(`/health/workouts/day?date=${dateStr}`);

// 생성
export const createWorkout = (payload) =>
    api("/health/workouts", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
    });

// 수정
export const updateWorkout = (id, payload) =>
    api(`/health/workouts/${id}`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
    });

// 삭제
export const deleteWorkout = (id) =>
    api(`/health/workouts/${id}`, {
        method: "DELETE",
    });


export const getLatestNearWorkout = () =>
    api("/health/workouts/latest-near");
